import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDur } from "@/lib/format";
import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PageTitle, Panel, Stat } from "./AdminLayout";
import { EventPicker } from "./EventPicker";
import { BarBox, LineBox, PieBox } from "./Charts";

export default function Analytics() {
  const [eid, setEid] = useState(null);
  const [a, setA] = useState(null);
  useEffect(() => {
    setA(null);
    api.get("/admin/analytics", { params: { event_id: eid || undefined } }).then((r) => setA(r.data));
  }, [eid]);
  return (
    <div>
      <PageTitle title="Analitik" desc="Peserta unik, kehadiran, dan rotasi climbing adalah metrik terpisah.">
        <EventPicker value={eid} onChange={setEid} allowAll testid="analytics-event-picker" />
      </PageTitle>
      {!a ? <Skeleton className="h-64 rounded-2xl" /> : (
        <>
          <div className="grid grid-cols-2 gap-3 md:grid-cols-4 xl:grid-cols-7">
            <Stat accent label="Peserta unik" value={a.unique_participants} testid="an-unique" />
            <Stat label="Total check-in" value={a.total_checkins} testid="an-checkins" />
            <Stat label="Rotasi selesai" value={a.completed_rotations} testid="an-completed" />
            <Stat label="Peserta baru" value={a.new_participants} testid="an-new" />
            <Stat label="Peserta kembali" value={a.returning_participants} testid="an-returning" />
            <Stat label="Rata-rata durasi" value={fmtDur(a.avg_duration_seconds)} testid="an-avg" />
            <Stat label="> 5 menit" value={`${a.overdue_pct}%`} sub={`${a.overdue_count} sesi`} testid="an-overdue" />
          </div>
          <div className="mt-6 grid gap-4 lg:grid-cols-2">
            <Panel title="Gender"><PieBox data={a.gender} /></Panel>
            <Panel title="Kelompok usia"><BarBox data={a.age} /></Panel>
            <Panel title="Kota domisili">
              <BarBox data={a.city} horizontal color="#3D6F4B" />
              <div className="mt-2 flex flex-wrap gap-2 text-xs">{a.city.map((c) => <span key={c.name} className="rounded-full bg-[#F5F3EB] px-2 py-0.5">{c.name}: {c.value} ({c.pct}%)</span>)}</div>
            </Panel>
            <Panel title="Kehadiran per bulan"><LineBox data={a.attendance_by_month} /></Panel>
            <Panel title="Kehadiran per event"><BarBox data={a.attendance_by_event} color="#5C7F55" /></Panel>
            <Panel title="Durasi per jalur">
              <Table data-testid="duration-by-route-table">
                <TableHeader><TableRow><TableHead>Jalur</TableHead><TableHead>Sesi</TableHead><TableHead>Rata-rata</TableHead><TableHead>&gt; 5 mnt</TableHead></TableRow></TableHeader>
                <TableBody>
                  {a.duration_by_route.map((r) => (
                    <TableRow key={r.name}><TableCell className="font-semibold">{r.name}</TableCell><TableCell className="font-mono">{r.count}</TableCell><TableCell className="font-mono">{fmtDur(r.avg_duration_seconds)}</TableCell><TableCell className="font-mono">{r.overdue_pct}%</TableCell></TableRow>
                  ))}
                </TableBody>
              </Table>
            </Panel>
          </div>
        </>
      )}
    </div>
  );
}
